import React from 'react'
import { connect } from 'react-redux'

class Footer extends React.Component {
    render() {
        const { subscriberCount, user } = this.props
        return (
            <footer id="footer">
                {user &&
                    <span>
                        <span>{subscriberCount.total} Subscribers ({subscriberCount.online} Online)</span>
                        <span>&nbsp;/&nbsp;</span>
                        <span>{subscriberCount.calls} Active Calls</span>
                    </span>
                }
                <span>{GIT_VERSION
                    .replace(/remotes\//gi, '')
                    .replace(/origin\//gi, '')
                    .replace(/heads\//gi, '')
                    .replace(/tags\//gi, '')}</span>
                <img src="img/srg_logos_footer.png" />
            </footer>
        )
    }
}

function mapStateToProps(state) {
    const { subscribers, calls } = state
    return {
        user: state.user,
        subscriberCount: {
            total: subscribers.length,
            online: subscribers.filter(s => s.online).length,
            calls: calls.length
        }
    }
}

export default connect(mapStateToProps)(Footer)


// WEBPACK FOOTER //
// ./containers/Footer.jsx